module.exports = __webpack_public_path__ + "static/media/signage-industrial-img34.6a7d753c.jpg";